/* tslint:disable */

declare var Object: any;
export interface TeomemppersonalInterface {
  "empId": string;
  "firstName": string;
  "middleName"?: string;
  "lastName": string;
  "gender": number;
  "userId"?: number;
  "taxno": string;
  "email"?: string;
  "photo"?: string;
  "geocoord"?: string;
  "status": number;
  "reqStatus": number;
  "lastreqno"?: string;
  "createdDate": Date;
  "createdBy": string;
  "modifiedDate": Date;
  "modifiedBy": string;
  "officialName"?: string;
  "initialName"?: string;
  "empImage"?: string;
  "empSignature"?: string;
  "fullName"?: string;
  "isent": number;
  "onboardingCompleted"?: number;
  "localName"?: string;
  rel_emppersonal?: any;
  rel_empaddress?: any[];
  rel_empcompany?: any[];
  tcltrequests?: any;
  rel_view_emp?: any;
}

export class Teomemppersonal implements TeomemppersonalInterface {
  "empId": string;
  "firstName": string;
  "middleName": string;
  "lastName": string;
  "gender": number;
  "userId": number;
  "taxno": string;
  "email": string;
  "photo": string;
  "geocoord": string;
  "status": number;
  "reqStatus": number;
  "lastreqno": string;
  "createdDate": Date;
  "createdBy": string;
  "modifiedDate": Date;
  "modifiedBy": string;
  "officialName": string;
  "initialName": string;
  "empImage": string;
  "empSignature": string;
  "fullName": string;
  "isent": number;
  "onboardingCompleted": number;
  "localName": string;
  rel_emppersonal: any;
  rel_empaddress: any[];
  rel_empcompany: any[];
  tcltrequests: any;
  rel_view_emp: any;
  constructor(data?: TeomemppersonalInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Teomemppersonal`.
   */
  public static getModelName() {
    return "Teomemppersonal";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Teomemppersonal for dynamic purposes.
  **/
  public static factory(data: TeomemppersonalInterface): Teomemppersonal{
    return new Teomemppersonal(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Teomemppersonal',
      plural: 'Teomemppersonals',
      path: 'Teomemppersonals',
      properties: {
        "empId": {
          name: 'empId',
          type: 'string'
        },
        "firstName": {
          name: 'firstName',
          type: 'string'
        },
        "middleName": {
          name: 'middleName',
          type: 'string'
        },
        "lastName": {
          name: 'lastName',
          type: 'string'
        },
        "gender": {
          name: 'gender',
          type: 'number'
        },
        "userId": {
          name: 'userId',
          type: 'number'
        },
        "taxno": {
          name: 'taxno',
          type: 'string'
        },
        "email": {
          name: 'email',
          type: 'string'
        },
        "photo": {
          name: 'photo',
          type: 'string'
        },
        "geocoord": {
          name: 'geocoord',
          type: 'string'
        },
        "status": {
          name: 'status',
          type: 'number'
        },
        "reqStatus": {
          name: 'reqStatus',
          type: 'number'
        },
        "lastreqno": {
          name: 'lastreqno',
          type: 'string'
        },
        "createdDate": {
          name: 'createdDate',
          type: 'Date'
        },
        "createdBy": {
          name: 'createdBy',
          type: 'string'
        },
        "modifiedDate": {
          name: 'modifiedDate',
          type: 'Date'
        },
        "modifiedBy": {
          name: 'modifiedBy',
          type: 'string'
        },
        "officialName": {
          name: 'officialName',
          type: 'string'
        },
        "initialName": {
          name: 'initialName',
          type: 'string'
        },
        "empImage": {
          name: 'empImage',
          type: 'string'
        },
        "empSignature": {
          name: 'empSignature',
          type: 'string'
        },
        "fullName": {
          name: 'fullName',
          type: 'string'
        },
        "isent": {
          name: 'isent',
          type: 'number'
        },
        "onboardingCompleted": {
          name: 'onboardingCompleted',
          type: 'number'
        },
        "localName": {
          name: 'localName',
          type: 'string'
        },
      },
      relations: {
        rel_emppersonal: {
          name: 'rel_emppersonal',
          type: 'any',
          model: ''
        },
        rel_empaddress: {
          name: 'rel_empaddress',
          type: 'any[]',
          model: ''
        },
        rel_empcompany: {
          name: 'rel_empcompany',
          type: 'any[]',
          model: ''
        },
        tcltrequests: {
          name: 'tcltrequests',
          type: 'any',
          model: ''
        },
        rel_view_emp: {
          name: 'rel_view_emp',
          type: 'any',
          model: ''
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/Teomemppersonal.ts